/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseBody
 */
export interface PurchaseBody {
    /**
     * The market item id to purchase
     * @type {string}
     * @memberof PurchaseBody
     */
    itemId: string;
}

/**
 * Check if a given object implements the PurchaseBody interface.
 */
export function instanceOfPurchaseBody(value: object): value is PurchaseBody {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    return true;
}

export function PurchaseBodyFromJSON(json: any): PurchaseBody {
    return PurchaseBodyFromJSONTyped(json, false);
}

export function PurchaseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['itemId'],
    };
}

export function PurchaseBodyToJSON(json: any): PurchaseBody {
    return PurchaseBodyToJSONTyped(json, false);
}

export function PurchaseBodyToJSONTyped(value?: PurchaseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itemId': value['itemId'],
    };
}

